import { AxiosResponse } from 'axios';
import { ICategoryDTO } from '../shared/interfaces/category-interfaces';
import api from './api';

interface IService {
  list: () => Promise<AxiosResponse<ICategoryDTO>>;
}

const categoryService: IService = {
  list: () => api.get('/category/'),
};

export default categoryService;
